
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/stackadapt",
      function () {
        return require("private-next-pages/destinations/stackadapt.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/stackadapt"])
      });
    }
  